export enum FromComeLocationEnum {
  INIT = 'init',
  LEFT = 'left',
}
